import React, { useCallback, useState } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { UnknownObject } from '../../../../../../react-app-env';

import CustomStepper from '../../../../../../components/CustomStepper';
import { CustomTransferListItem } from '../../../../../../components/CustomTransferList';
import { Area, Category, validationErrors, ValidationErrors, AreaReducerAction, validation } from '../..';
import StepDetails from '../StepDetails';
import StepCategories from '../StepCategories';
import StepReview from '../StepReview';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  completeLabel: string;
  area: Area;
  categories: Category[];
  dispatch: React.Dispatch<{ type: AreaReducerAction; value: any }>;
  handleSave: () => void;
}

const AreaSteps = ({ classes, completeLabel, area, categories, dispatch, handleSave }: Props): React.ReactElement => {
  const [step, setStep] = useState<number>(0);

  const [errors, setErrors] = useState<ValidationErrors>({
    name: false,
  });

  const validate = useCallback(
    (_step: number) => {
      const errorItems: UnknownObject = {};
      if (_step === 0) {
        errorItems.name = validation.name(area.name);
      }
      setErrors({ ...errors, ...errorItems });
      return (Object.keys(errorItems) as Array<keyof typeof validationErrors>).some((i) => errorItems[i]);
    },
    [area, errors]
  );

  const handleCategoryAssignment = (_: unknown, assigned: CustomTransferListItem[]) => {
    const assignedIds = assigned.map((i) => i.id);
    const a = categories.filter((i: Category) => assignedIds.includes(i.id));
    dispatch({ type: AreaReducerAction.UPDATE_CATEGORIES, value: a });
  };

  return (
    <>
      <CustomStepper
        step={step}
        isNextDisabled={(Object.keys(errors) as Array<keyof typeof errors>).some((i) => errors[i])}
        completeLabel={completeLabel}
        setStep={setStep}
        validate={validate}
        handleComplete={handleSave}>
        {[
          {
            label: 'Details',
            component: <StepDetails area={area} errors={errors} setErrors={setErrors} dispatch={dispatch} />,
          },
          {
            label: 'Grouping assignment',
            gridSize: 8,
            component: (
              <StepCategories
                items={categories.map((c: Category) => ({ id: c.id, label: c.name }))}
                assigned={area.categories.map((c: Category) => ({ id: c.id, label: c.name }))}
                handleAssignment={handleCategoryAssignment}
              />
            ),
          },
          {
            label: 'Summary',
            component: <StepReview area={area} setStep={setStep} />,
          },
        ]}
      </CustomStepper>
    </>
  );
};

export default withStyles(styles)(AreaSteps);
